import { Conversation } from "@accurx/concierge/types";

export const getConversationRequestType = (
    conversation: Conversation,
): string | null => {
    if (conversation.items[0]?.contentType !== "PatientTriageRequestNote")
        return null;
    return conversation.items[0].requestTitle;
};
